import { Router } from '@angular/router';
import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { JobOffersService } from 'app/services';
import { ToasterService } from 'angular2-toaster';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';

@Component({
  selector: 'app-close-job-button',
  templateUrl: './close-job-button.component.html',
  styleUrls: ['./close-job-button.component.scss']
})
export class CloseJobButtonComponent implements OnInit {
  @Input() id: number;
  @Input() type: 'button' | 'icon' = 'button';
  @Input() state: 'published' | 'processing' | 'paused' = 'paused';

  @ViewChild('template') template: TemplateRef<any>;

  modalRef: BsModalRef;

  public isLoading: boolean = false;
  constructor(
    private jos: JobOffersService,
    private router: Router,
    private toaster: ToasterService,
    private modalService: BsModalService
  ) { }

  ngOnInit() {
  }

  async openModal() {
    this.modalRef = this.modalService.show(this.template);
  }

  modalClose() {
    this.modalRef.hide();
  }

  public async confirm() {
    this.isLoading = true;
    await this.jos.updateState(this.id).toPromise();
    this.modalClose();
    this.isLoading = false;
    this.toaster.pop('success', `Job Closed successfully.`);
    this.router.navigate(['/recruiting']);
  }

  async close(): Promise<void> {
    switch (this.state) {
      case 'published': {
        this.openModal();
        break;
      }
      case 'processing':
      case 'paused': {
        this.toaster.pop('error', `You can't update a job offer in ${this.state} state.`);
        break;
      }
      default:
        return;
    }
  }
}
